type BrandMarkProps = {
  className?: string;
  variant?: 'compact' | 'hero';
};

function BrandMark({ className = '', variant = 'compact' }: BrandMarkProps) {
  const rootClassName = [
    'select-none',
    variant === 'hero' ? 'flex flex-col items-center gap-4 text-center' : 'flex items-center gap-3',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const badgeClassName = [
    'flex items-center justify-center rounded-md border border-primary/40 bg-primary/10 font-semibold uppercase text-primary',
    variant === 'hero' ? 'h-16 w-16 text-lg tracking-[0.32em]' : 'h-9 w-9 text-[11px] tracking-[0.28em]',
  ].join(' ');

  const titleClassName = [
    'font-semibold uppercase text-foreground',
    variant === 'hero' ? 'text-[30px] tracking-[0.3em]' : 'text-sm tracking-[0.22em]',
  ].join(' ');

  const subtitleClassName = [
    'uppercase text-muted-foreground',
    variant === 'hero' ? 'text-xs tracking-[0.3em]' : 'text-[10px] tracking-[0.22em]',
  ].join(' ');

  return (
    <div className={rootClassName}>
      <div className={badgeClassName}>MC</div>
      <div className={variant === 'hero' ? 'space-y-2' : 'flex flex-col leading-none'}>
        <div className={titleClassName}>Med Curation</div>
        <div className={subtitleClassName}>Medical Imaging</div>
      </div>
    </div>
  );
}

export default BrandMark;